import Typography, {
  TYPOGRAPHY_VARIANTS,
  TYPOGRAPHY_SIZES,
  FontWeight,
} from './Typography'
import {
  Display,
  Heading,
  Paragraph,
  Label,
  ButtonLabel,
  Link,
} from './TypographyComponents'

export { TYPOGRAPHY_VARIANTS, TYPOGRAPHY_SIZES }
export type { FontWeight }
export { Display, Heading, Paragraph, Label, ButtonLabel, Link }

export { Typography }
